import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    overlay: {
      height: '100%',
      width: 0,
      position: 'fixed',
      zIndex: 1200,
      top: 0,
      right: 0,
      overflowX: 'hidden',
      transition: '0.5s',
      background: theme.palette.secondary.dark,
      paddingTop: 80,
      [theme.breakpoints.up('xl')]: {
        height: 'unset',
        position: 'relative',
        width: 'auto',
        paddingTop: 0,
        zIndex: 1,
        paddingRight: MIDDLE_MARGIN,
      },
    },
    overlayOpen: {
      width: '100%',
      padding: 24,
      [theme.breakpoints.up('sm')]: {
        padding: 30,
      },
    },
    contentWrapper: {
      overflow: 'hidden',
    },
    overlayLogoWrapper: {
      display: 'flex',
      height: 45,
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        height: 60,
      },
      '& img': {
        height: '100%',
      },
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      margin: `${MIDDLE_MARGIN}px 0`,
    },
    closeIcon: {
      width: 14,
      height: 14,
    },
    buttonsWrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: `${MIDDLE_MARGIN}px 0`,
      '& button:last-child:not(:only-child)': {
        marginLeft: SMALL_MARGIN,
      },
    },
    applyBtn: {
      minWidth: 139,
    },
  }),
);

export default useStyles;
